/**
 * Helper
 */
var helper = require('../../helper'),
    dataTables_buttons = [
        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'print',
            text: 'Print table',
            exportOptions: {
                columns: '.data-export'
            },
            className: 'btn btn-default'
        },
        {
            extend: 'colvis',
            className: 'btn btn-default'
        }

    ];

$(function() {
    var $datatable = $('#datatable-petty-cash'),
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/finance/petty-cash",
            "method": 'POST',
            "data": function ( d ) {

            }
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
            {data: 'employee', name: 'employee', className: 'data-export'},
            {data: 'date', name: 'date', className: 'data-export'},
            {data: 'description', name: 'description', className: 'data-export'},
            {data: 'amount', name: 'amount', className: 'data-export'},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action"}
        ],
        "initComplete": function(settings, json) {
            // init callback
        }
    });

});
